import { PropertyDetails } from "./cardChips";
import { useNavigate } from "react-router-dom";
import bedIcon from "../../../assets/bedIcon.svg";
import SqftIcon from "../../../assets/sqftIcon.svg";
import bathIcon from "../../../assets/bathIcon.svg";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { useAuth } from "../../../context/authProvider";
import { reactions } from "../../../services/reactions";
import { formatPrice } from "../../../utils/formatPrice";
import { formatDate } from "../../../utils/dateFormatter";
import { useNavbarStore } from "../../../stores/navBarStatus";
import { useUserProfileStore } from "../../../stores/profileStore";
import { convertToFormattedAmount } from "../../../utils/convertAmount";
import type { SearchListingInterface } from "../../../services/exploreListings";
import {
	useEffect,
	useState,
	type KeyboardEvent,
	type MouseEvent,
} from "react";

import "swiper/css";

interface ListCardProps {
	property: SearchListingInterface;
}

const FallbackImage =
	"data:image/jpeg;base64,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";

const truncateAddress = (address: string, maxLength: number) => {
	if (address.length > maxLength) {
		return `${address.slice(0, maxLength)}...`;
	}
	return address;
};

const ListCard = ({ property }: ListCardProps) => {
	const [liked, setLiked] = useState<boolean>(false);
	const { showNavbar } = useNavbarStore();
	const { userProfile } = useUserProfileStore();
	const navigate = useNavigate();
	const { isWebview } = useAuth();

	useEffect(() => {
		const isLiked = userProfile?.likedHomes?.some(
			(home) => home.listingId === property.listingId,
		);
		setLiked(!!isLiked);
	}, [userProfile, property.listingId]);

	const propertyImg = property.images
		? property.images[0]
		: property.displayImageUrl
			? property.displayImageUrl
			: FallbackImage;

	const handleKeyPress = (
		event: KeyboardEvent<HTMLDivElement>,
		zlid: string,
	) => {
		if (event.key === "Enter" || event.key === " ") {
			navigate(`/listing/${zlid}`);
		}
		showNavbar();
	};

	const handleListingClick = (zlid: string) => {
		navigate(`/listing/${zlid}`);
		showNavbar();
	};

	const handleLike = async (
		event: MouseEvent<HTMLButtonElement>,
	): Promise<void> => {
		event.stopPropagation();

		if (liked) {
			await reactions(property.listingId, "REMOVE_SAVED_LISTING");
			setLiked(false);
		} else if (!liked) {
			await reactions(property.listingId, "SAVE_LISTING");
			setLiked(true);
		}
	};

	const rawDate = (property.listDate as unknown as string).split("T")[0]; // Extract the date part
	const [year, month, day] = rawDate.split("-").map(Number); // Parse the year, month, and day

	// Create a new Date object for the date
	const dateInToronto = new Date(year, month - 1, day); // No offset applied

	// Get today's date for comparison (without time)
	const today = new Date();
	today.setHours(0, 0, 0, 0); // Reset hours to start of the day

	// Calculate the difference in days
	const timeDifference = today.getTime() - dateInToronto.getTime();
	const dayDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

	// Determine the display format
	let displayDate = "";
	if (dayDifference === 0) {
		displayDate = "Today";
	} else if (dayDifference > 0) {
		displayDate =
			dayDifference === 1 ? "1 day ago" : `${dayDifference} days ago`;
	} else {
		// If it's a future date, handle gracefully
		const futureDays = -dayDifference;
		displayDate =
			futureDays === 1 ? "1 day from now" : `${futureDays} days from now`;
	}

	// Fallback to showing the year if outside of "Today" or "days ago" range
	if (Math.abs(dayDifference) > 365) {
		displayDate = year.toString(); // Use the extracted year
	}

	return (
		<div
			key={property.listingId}
			className="bg-white rounded-[10px] h-full shadow-xl flex items-center w-full gap-1"
			onClick={() => handleListingClick(property.listingId)}
			onKeyDown={(event) => handleKeyPress(event, property.listingId)}
		>
			<div className="h-[144px] w-[144px]">
				<img
					src={propertyImg}
					alt={property.listingId}
					className="h-[144px] w-full object-cover  rounded-l-[10px]"
					onError={(e) => {
						e.currentTarget.src = FallbackImage;
						e.currentTarget.alt = "Image not available";
					}}
				/>
			</div>
			<div className="w-full py-3 px-2 flex flex-col justify-between h-full">
				<div>
					<div className="w-full relative text-xs text-black flex-wrap flex items-center">
						<div className="flex-1 text-xl text-black font-bold flex items-center">
							{`$${formatPrice(convertToFormattedAmount(property.listPrice))}`}
						</div>
						{!isWebview && (
							<button
								type="button"
								className="flex-2 focus:outline-none w-10 h-10 absolute right-0 flex items-center justify-end"
								onClick={(e) => handleLike(e)}
							>
								{liked ? (
									<FaHeart className="text-[#FF5757] text-xl" />
								) : (
									<FaRegHeart className="text-[#FF5757] text-xl" />
								)}
							</button>
						)}
					</div>
					<div className="flex flex-wrap items-center text-z-dark-moss-green text-[11.5px] font-bold w-full justify-between">
						<div className="w-7/10 whitespace-nowrap tracking-tight">
							Down Payment Contribution
						</div>
						<div className="w-px h-3 bg-gray-400 mx-2" />
						<div className="w-3/10 flex justify-between pr-1">
							{`${
								property.downPaymentContribution
									? `$${formatPrice(
											convertToFormattedAmount(
												property.downPaymentContribution,
											),
										)}`
									: "N/A"
							}`}
						</div>
					</div>

					{property.displayAddress && (
						<div className="text-sm text-black font-light">
							{truncateAddress(property.displayAddress, 30)}
						</div>
					)}

					<div className="text-sm flex items-center gap-3">
						<PropertyDetails
							icon={bedIcon}
							label="Beds"
							value={
								property.numBedrooms ? property.numBedrooms.toString() : "N/A"
							}
						/>
						<PropertyDetails
							icon={bathIcon}
							label="Baths"
							value={
								property.numBathrooms ? property.numBathrooms.toString() : "N/A"
							}
						/>
						<PropertyDetails
							icon={SqftIcon}
							label="Sqft"
							value={property.sqft ? `${formatPrice(property.sqft)}` : "N/A"}
						/>
					</div>
				</div>

				<div className="w-full text-xs text-black pt-2 flex items-end justify-end">
					<div className="flex-2 text-right flex items-center justify-end">
						<span className="inline-block w-2.5 h-2.5 bg-[#6ECE35] rounded-full mr-1" />
						{formatDate(property.listDate)}
					</div>
				</div>
			</div>
		</div>
	);
};

export { ListCard };
